import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useApp } from "@/context/AppContext";
import { Loader2 } from "lucide-react";

export const ProtectedRoute = ({ children, allowIncomplete = false, adminOnly = false, sellerOnly = false }) => {
  const { user } = useAuth();
  const { t } = useApp();

  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="flex items-center gap-2 text-neutral-500">
          <Loader2 className="h-5 w-5 animate-spin" /> {t("common.loading")}
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/connexion" replace />;
  if (adminOnly) {
    if (user.role !== "admin") return <Navigate to="/dashboard" replace />;
    return children;
  }
  if (!allowIncomplete && !user.company_id) return <Navigate to="/completer-profil" replace />;
  if (sellerOnly && !user.can_sell) return <Navigate to="/dashboard" replace />;
  return children;
};
